/**
 * Erstkontakt: Woher kam dieser Browser beim allerersten Besuch?
 *
 * Shopify merkt sich im Kundenweg einer Bestellung nur Besuche aus den Wochen
 * davor. Wer vor einem Jahr über eine Anzeige kam, den Newsletter abonniert hat
 * und jetzt über eine Mail kauft, erscheint dort als „Newsletter" — der echte
 * Ursprung ist verloren. Dieses Skript hält ihn fest:
 *
 *   - beim ersten Besuch: Datum, Referrer (nur fremde Seiten), Einstiegsseite,
 *     utm-Parameter und ob eine Klick-Kennung von Google/Meta/Microsoft dabei war
 *   - in localStorage, zwei Jahre lang; wird nie überschrieben
 *   - als verstecktes Warenkorb-Attribut `_erstkontakt` (einmal je Sitzung), damit
 *     es an der Bestellung ankommt — das WMS liest es in ShopOrderOrigin
 *   - für die Newsletter-Anmeldung über window.gdErstkontakt()
 *
 * Keine personenbezogenen Daten: keine Kennungen, keine Klick-IDs selbst, nur
 * dass es eine gab.
 */
(function () {
  'use strict';

  var SCHLUESSEL = 'gd_erstkontakt';
  var LAUFZEIT_TAGE = 730;

  function lesen() {
    try {
      var v = JSON.parse(localStorage.getItem(SCHLUESSEL) || 'null');
      if (v && v.t && Date.now() - Date.parse(v.t) < LAUFZEIT_TAGE * 864e5) return v;
    } catch (e) {}
    return null;
  }

  function kuerzen(s, n) {
    return s ? String(s).slice(0, n) : undefined;
  }

  function erfassen() {
    var u = new URL(location.href);
    var p = u.searchParams;
    var ref;
    try {
      var r = document.referrer ? new URL(document.referrer) : null;
      // Eigene Seiten (auch Checkout und Länder-Shops) sind kein Ursprung
      if (r && !/(^|\.)get-?digital\.|myshopify\.com$|shopify\.com$/i.test(r.hostname)) ref = r.origin + r.pathname;
    } catch (e) {}
    var v = {
      t: new Date().toISOString(),
      ref: kuerzen(ref, 200),
      lp: kuerzen(u.pathname, 200),
      us: kuerzen(p.get('utm_source'), 80),
      um: kuerzen(p.get('utm_medium'), 80),
      uc: kuerzen(p.get('utm_campaign'), 120),
      klick: p.has('gclid') || p.has('gbraid') || p.has('wbraid') ? 'google' : p.has('fbclid') ? 'meta' : p.has('msclkid') ? 'microsoft' : undefined,
    };
    try { localStorage.setItem(SCHLUESSEL, JSON.stringify(v)); } catch (e) {}
    return v;
  }

  var erstkontakt = lesen() || erfassen();

  window.gdErstkontakt = function () {
    return erstkontakt;
  };

  // Einmal je Sitzung an den Warenkorb hängen. Der Unterstrich verbirgt das
  // Attribut im Checkout. Ohne Warenkorb legt Shopify dabei einen leeren an,
  // das ist harmlos.
  function anhaengen() {
    try {
      if (sessionStorage.getItem(SCHLUESSEL)) return;
      sessionStorage.setItem(SCHLUESSEL, '1');
    } catch (e) {
      return;
    }
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _erstkontakt: JSON.stringify(erstkontakt) } }),
    }).catch(function () {
      try { sessionStorage.removeItem(SCHLUESSEL); } catch (e) {}
    });
  }

  if ('requestIdleCallback' in window) requestIdleCallback(anhaengen, { timeout: 4000 });
  else setTimeout(anhaengen, 2000);
})();
